<template>
  <div class="h-100 d-flex flex-column">
    <section :class="userData.isAndroid
        ? 'padding-nevigate-bar-ANDROID'
        : 'padding-nevigate-bar-IOS'
      " class="common-upload-header" v-if="userData.channel != 'WEB'">
      <div class="row no-gutters">
        <div class="col-2 px-0 justify-content-center align-self-center">
          <div @click="goToPreviousPage()">
            <b-img center :src="iconBack" width="24" height="24"></b-img>
          </div>
        </div>
        <div class="col-8 justify-content-center align-self-center">
          <div class="upload-header mx-0 text-center">
            {{ this.currentMenu.pageName }}
          </div>
        </div>
        <div class="col-2 px-0"></div>
      </div>
    </section>

    <div class="justify-content-md-center p-3 d-flex flex-column justify-content-between h-100"
      :style="userData.isAndroid ? '' : 'overflow-y: scroll;'">
      <div>
        <div class="justify-content-center">
          <b-row>
            <b-col class="upload-header">
              {{ documentType.doc_short_name }}
            </b-col>
          </b-row>
          <div class="mt-3"></div>
          <div class="mb-3 justify-content-md-center" v-for="(item, key) in documentType.list_doc" :key="key">
            <div>
              <div class="row">
                <div class="col-10">
                  <b-row class="py-1">
                    <b-col cols="1">
                      <b-badge pill variant="primary"><span class="text-center badge-ktb-info" style="
                            position: absolute;
                            top: 20%;
                            left: 40%;
                            line-height: 12px;
                          ">
                          {{ key + 1 }}
                        </span></b-badge>
                    </b-col>
                    <b-col class="text-left text-ktb-regular-16" style="margin-left: 6px">
                      <span class="align-bottom" style="line-height: 1">{{
                        item
                      }}</span></b-col>
                  </b-row>
                </div>
              </div>
            </div>
          </div>
          <b-row style="display: none">
            <b-col style="text-align: center">
              <a href="" class="view-example">ดูตัวอย่างเอกสาร</a>
            </b-col>
          </b-row>
          <hr />
          <div class="mb-1 d-flex justify-content-center" v-if="
            documentType.reason_request != undefined &&
            documentType.reason_request != ''
          ">
            <b-card class="border-radius-1rem mt-2 card-doc-err pt-1 pb-3" body-class="py-1">
              <div class="py-2">
                <b-icon icon="exclamation-triangle-fill" style="color: white; width: 24px; height: 24px"></b-icon>
                <b class="card-doc-err-detail">
                  &nbsp; {{ documentType.reason_request }}
                </b>
              </div>
              <div class="card-doc-err-detail">
                {{ documentType.reason_note }}
              </div>
            </b-card>
          </div>
          <div class="mb-1">
            <div class="row">
              <div class="col-10">
                <b-row class="py-1">
                  <b-col class="text-ktb-bold-16">
                    {{ "เอกสารที่ต้องการอัปโหลด" }}
                  </b-col>
                </b-row>
                <b-row class="py-1">
                  <b-col>
                    <span class="text-ktb-regular-16-grey">รองรับไฟล์ JPG,PNG,HEIC และ PDF
                    </span>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </div>
        <b-overlay :show="isConvertingHeic" rounded="sm">
          <div>
            <b-card no-body v-if="getListFileByType().length > 0" class="border-radius-1rem mt-2 mb-3"
              body-class="py-0">
              <!-- <b-container > -->
              <div v-for="(readItem, key) in getListFileByType()" v-bind:key="readItem.id">
                <b-row class="py-3 px-3 no-gutters" align-v="center" style="margin-right: 0px; margin-left: 0px">
                  <b-col cols="auto mr-3">
                    <!-- <b-img
                      width="43"
                      height="43"
                      :src="getPreview(readItem.id)"
                      :class="'preview-' + getFileType(readItem.id)"
                      @click="viewDoc(readItem.id)"
                    ></b-img> -->
                    <b-img width="43" height="43" :src="getPreview(readItem.id)"
                      :class="'preview-' + getFileType(readItem.id)"></b-img>
                  </b-col>

                  <!-- <b-col
                    cols="8"
                    class="text-muted"
                    @click="viewDoc(readItem.id)"
                    :id="'Upload_ViewDoc_' + readItem.type"
                    align-self="center"
                  > -->
                  <b-col cols="8" class="text-muted" :id="'Upload_ViewDoc_' + readItem.type" align-self="center">
                    <div class="content-nowrap text-ktb-regular-16">
                      {{ readItem.filename }}
                    </div>
                    <div class="text-ktb-regular">
                      {{ getFileSize(readItem.filesize) }}
                    </div>
                  </b-col>
                  <template v-if="!checkDocIsSuccess()">
                    <b-col cols="auto ml-auto" class="" @click="remove(readItem.id)" style="cursor: pointer">
                      <div style="color: #087ffd">
                        <b-img :id="'Upload_RemoveDoc_' + readItem.type" :src="iconTrash" width="24"
                          height="24"></b-img>
                      </div>
                    </b-col>
                  </template>
                </b-row>
                <b-row v-if="readItem.fileHavePassword" class="pb-3 mx-1">
                  <b-col><span class="text-ktb-bold">รหัสผ่านเอกสาร </span>
                  </b-col>
                  <div class="w-100 py-1" />
                  <b-col>
                    <b-form-input style="font-size: 13.6px" size="lg" type="password" placeholder="กรุณาใส่รหัสผ่าน"
                      aria-describedby="input-live-help input-live-feedback"
                      @blur="validateFileHavePassword(readItem, $event)"
                      :state="readItem.fileCheckassword"></b-form-input>
                    <b-form-invalid-feedback id="input-live-feedback">
                      รหัสผ่านไม่ถูกต้อง
                    </b-form-invalid-feedback>
                  </b-col>
                </b-row>
                <div v-if="key + 1 != getListFileByType().length">
                  <hr class="hr-style" />
                </div>
              </div>

              <!-- </b-container> -->
            </b-card>
            <div class="pb-3 d-flex justify-content-center">
              <input id="fileUpload" @change="onFileChange($event)" type="file" multiple hidden :accept="acceptFile" />

              <input id="fileBrowseImage" @change="onFileChange($event)" type="file" hidden multiple
                accept="image/jpeg,image/png,image/jpg,image/heic" />

              <input id="fileBrowseIOS" @change="onFileChange($event)" type="file" hidden multiple
                accept="image/jpeg,image/png,image/jpg,image/heic,application/pdf" />

              <input id="fileBrowseFile" @change="onFileChange($event)" type="file" hidden accept="application/pdf" />

              <input id="fileCamera" @change="onFileChange($event)" type="file" capture hidden
                accept="image/jpeg,image/png,image/jpg,image/heic" />

              <button :id="'upload_chooseFiles_' + documentType.doc_code" @click="chooseFiles()" class="upload-button"
                :disabled="checkDocIsSuccess()">
                <b-img :src="iconUploads" width="24" height="24" />
                &nbsp;
                <span :class="checkDocIsSuccess()
                    ? 'text-ktb-bold text-grey '
                    : 'text-ktb-bold text-blue'
                  ">เลือกเอกสาร
                </span>
              </button>
            </div>
            <div>
              <div v-if="!checkLimit()" class="pt-3 text-danger">
                กรุณาลดขนาดไฟล์แล้วลองใหม่อีกครั้ง
              </div>
              <!-- <div v-if="!validateTotalPdf()" class="pt-3 text-danger">
                กรุณากรอกรหัสผ่านไฟล์ให้ครบถ้วน
              </div> -->
              <div class="pt-2">
                <b-progress :value="getAllSize()" :variant="getColorProgress()" :max="max"
                  class="mb-2 progress-upload-custom"></b-progress>
              </div>
              <b-row class="size-memory py-1 text-center">
                <b-col>
                  <span style="color: rgb(90, 110, 123) !important">ใช้ไปแล้ว
                  </span>
                  <span :class="'danger-' + !checkLimit()">{{
                    getAllSize() + "/" + max
                  }}</span>
                  <span style="color: rgb(90, 110, 123) !important">
                    MB
                  </span></b-col>
              </b-row>
            </div>
          </div>
        </b-overlay>
      </div>
      <div v-if="!checkDocIsSuccess()" class="margin-btn-footer">
        <button :class="'btn btn-info btn-block btn-ktb-' + userData.channel" @click="doSubmit()" id="Upload_Accept"
          :disabled="!checkLimit() || !validateTotalPdf() || realFiles.length == 0
            ">
          <template> ดำเนินการต่อ </template>
        </button>
      </div>
    </div>

    <b-modal v-model="modalShow" hide-header hide-header-close hide-footer centered
      content-class="modal-attachfile-modal_content" dialog-class="mb-4">
      <div class="px-3 pb-4 justify-content-center">
        <b-row style="float: left">
          <b-col><span class="text-ktb-bold-16">เลือกรูปแบบ</span></b-col>
          <div class="w-100 py-2" />
          <b-col @click="selectedOptionFile(1)" :id="'upload_file_camera_' + documentType.doc_code">
            <b-img left :src="iconCamera" class=""></b-img>
            <span class="px-3 text-ktb-regular-16">ถ่ายรูป</span>
          </b-col>
          <div class="w-100 px-3">
            <hr />
          </div>
          <b-col @click="selectedOptionFile(2)" :id="'upload_file_browseImages_' + documentType.doc_code">
            <b-img left :src="iconBrowseImages"></b-img>
            <span class="px-3 text-ktb-regular-16">อัลบั้มรูป</span>
          </b-col>
          <div class="w-100 px-3">
            <hr />
          </div>
          <b-col @click="selectedOptionFile(3)" :id="'upload_file_browseFiles_' + documentType.doc_code">
            <b-img left :src="iconBrowseFile" height="20" width="20"></b-img>
            <span style="margin-left: 4px" class="px-3 text-ktb-regular-16">เลือกไฟล์</span>
          </b-col>
          <div class="w-100 pb-3"></div>
        </b-row>
      </div>
    </b-modal>

    <b-modal v-model="modalShowBackStep" hide-header hide-header-close hide-footer content-class="content-dialog-back">
      <div class="justify-content-center">
        <b-row>
          <b-col style="text-align: center"><span
              class="text-ktb-bold-18-black">ยืนยันการออกจากหน้านี้?</span><br />เอกสารที่เลือกไว้จะถูกบันทึก</b-col>
          <div class="w-100">
            <hr style="margin-bottom: unset" />
          </div>
        </b-row>

        <b-row>
          <b-col style="text-align: center; padding-right: 0px; padding-left: 0px">
            <b-button style="border-right-color: rgb(229 229 229)" class="btn-back-step pt-2"
              @click="closeModalShowBackStep()">
              <span class="text-ktb-bold-18-blue">ยกเลิก</span>
            </b-button>
          </b-col>

          <b-col style="text-align: center; padding-right: 0px; padding-left: 0px">
            <b-button class="btn-back-step pt-2" @click="backPage()">
              <span class="text-ktb-bold-18-blue">ออกจากหน้านี้</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { convertFileCloudToLocal } from "@/utils/Upload.js";
import heic2any from "heic2any";
import pdf from "vue-pdf";
export default {
  data() {
    return {
      isConvertingHeic: false,
      imgBgNEXT: require("@/assets/images/Upload Documents@3x.png"),
      iconUploads: require("@/assets/images/iconSelectUpload.png"),
      iconTrash: require("@/assets/images/iconTrash.png"),
      iconCamera: require("@/assets/images/Camera.png"),
      iconBrowseFile: require("@/assets/images/Mail Policy@3x.png"),
      iconBrowseImages: require("@/assets/images/Gallery.png"),
      max: 0,
      documentType: {},
      maxsize: parseInt(process.env.VUE_APP_MAXSIZE),
      limit: parseInt(process.env.VUE_APP_LIMITFILE),
      acceptFile: process.env.VUE_APP_ACCEPTFILE,
      timeout: parseInt(process.env.VUE_APP_TIMEOUT),
      userData: {},
      isalert: false,
      visible: false,
      modalShow: false,
      modalShowBackStep: false,
      size: 0,
      file: {
        option: null,
        placeholder: "กรุณาเลือกประเภทของข้อมูล",
      },
      files: [],
      realFiles: [],
      fileCountId: 0,
      collapseObj: {},
      fileGroupList: [],
      GroupDocDisplay: [],
      alert: {
        title: null,
        textclose: null,
        size: {
          title: "ขนาดไฟล์เกินกำหนด",
          detail:
            "ขนาดรวมของไฟล์ทั้งหมดจะต้องไม่เกิน " +
            process.env.VUE_APP_MAXSIZE +
            " MB",
          close: "ตกลง",
        },
        data: {
          title: "ยังไม่ได้เลือกไฟล์",
          detail: "กรุณาตรวจสอบและเลือกไฟล์เอกสารอีกครั้ง",
          close: "ตกลง",
        },
        typefile: {
          title: "ประเภทของไฟล์ไม่ถูกต้อง",
          detail: "กรุณาเลือกประเภทของไฟล์ได้แก่ PDF,PNG,JPG หรือ HEIC",
          close: "ตกลง",
        },
        option: {
          title: "ไม่พบประเภทข้อมูล",
          detail: "กรุณาตรวจสอบและเลือกประเภทข้อมูลที่ต้องการเพิ่ม",
          close: "ตกลง",
        },
        filenameDuplicate: {
          title: "ชือไฟล์ซ้ำในระบบ",
          detail: "กรุณาเปลี่ยนชื่อไฟล์แล้วกรุณาลองใหม่อีกครั้ง",
          close: "ตกลง",
        },
        error: {
          title: "เกิดข้อผิดพลาด",
          detail:
            "เกิดข้อผิดพลาดในการประมวลผลข้อมูลจากระบบ กรุณาลองใหม่อีกครั้ง",
          close: "ตกลง",
        },
        sizeAndTypeFile: {
          title: "กรุณาตรวจสอบไฟล์",
          detail:
            "ประเภทของไฟล์ที่รองรับได้แก่ .pdf, .png, .jpg หรือ .heic เท่านั้น โดยขนาดข้อมูลรวมกันต้องมีขนาดไม่เกิน " +
            process.env.VUE_APP_MAXSIZE +
            " MB",
          close: "ตกลง",
        },
        fileEmpty: {
          title: "ขนาดไฟล์ไม่ถูกต้อง",
          detail: "กรุณาตรวจสอบขนาดไฟล์อีกครั้ง",
          close: "ตกลง",
        },
      },
      form: {
        title: "อัปโหลดไฟล์เอกสาร",
        file_label: "กรุณาเลือกไฟล์",
        add: "เพิ่มเอกสาร",
        view: "ดูเอกสาร",
        remove: "นำออก",
        credit: {
          title: "คํารับรองการขอสินเชื่อ",
          detail:
            "ข้าพเจ้าขอรับรองว่าข้อความและ/หรือเอกสารที่ข้าพเจ้าได้แจ้งและ/หรือจัดส่งให้แก่ธนาคารนี้เป็นข้อมูลปัจจุบัน ถูกต้องและตรงตามความเป็นจริงทุกประการ และหากมีการแก้ไขเปลี่ยนแปลงข้อมูลและ/หรือเอกสารใดที่ได้ให้ไว้กับธนาคาร ข้าพเจ้าจะแจ้งให้ธนาคารทราบทันที",
        },
        confirm: "ยอมรับ",
        cancel: "ยกเลิก",
      },
      docTypeItem: {},
      listMsg: [
        "กดปุ่มเลือกไฟล์เอกสาร และจึงเลือกไฟล์เอกสาร PDF หรือรูปภาพ PNG, JPEG หรือ HEIC ที่ต้องการนำส่ง",
        "หากมีไฟล์เอกสารหลายหน้า สามารถกดเลือกไฟล์เอกสารเพิ่มได้",
        "ตรวจสอบความถูกต้องของไฟล์เอกสารทั้งหมดที่เลือก และตรวจสอบว่าขนาดรวมของไฟล์ทุกไฟล์และทุกประเภท จะไม่เกิน 20 MB",
        "กดปุ่มอัปโหลดไฟล์เอกสารที่อยู่ล่างสุด และโปรดรอสักครู่ระหว่างรอไฟล์เอกสารทั้งหมดอัปโหลด",
      ],
      ImgProps: { width: 30, height: 30 },
      showStatusImg: {
        0: "",
        1: "ไฟล์ใช้ไม่ได้",
        2: "รูปภาพไม่ชัดเจน",
        3: "อัปโหลดสำเร็จ",
        4: "ไฟล์ไม่สมบูรณ์",
        5: "อัปโหลดไม่สำเร็จ",
        6: "กำลังประมวลผล",
        99: "ไฟล์มีปัญหา",
      },
      grp_id: null,
      currentMenu: null,
      iconBack: require("@/assets/images/Back Arrow Icon.png"),
    };
  },
  created() {
    try {
      this.$callback.enterFullScreen();
    } catch (err) {
      //console.error(err);
    }
    this.userData = this.$store.getters.getUserData;
    this.grp_id = this.userData.grpId;
    this.currentMenu = {
      pageCode: "CommonUpload",
      pageName: this.userData.document_group_type.find(
        (i) => i.grp_id == this.userData.grpId
      ).grp_name,
      previousPage: this.userData.routerPath.documentGroup,
      params: { grpId: this.userData.grpId },
      isShow: true,
    };
    this.$event.$emit("update_current_menu", this.currentMenu);

    if (!this.userData.token) this.goLandingPage();
    this.documentType = this.userData.documentType.find(
      (v) => v.doc_code == this.$route.params.doc_code
    );
    if (this.documentType === undefined) this.goLandingPage();
    try {
      if (
        this.documentType.doc_desc != undefined &&
        this.documentType.doc_desc.length > 0
      ) {
        this.documentType.list_doc = this.documentType.doc_desc.split("|");
      }
    } catch (error) {
      console.error(error);
    }

    this.max = this.maxsize;
    if (this.documentType.max_size != undefined) {
      this.max = this.documentType.max_size;
    }
  },
  mounted() {
    try {
      this.initData();
      //Order Display
      if (this.files.filter((item) => !item.deviate_flag).length > 0)
        this.GroupDocDisplay.push(
          this.files.filter((item) => !item.deviate_flag)
        );
      if (this.files.filter((item) => item.deviate_flag).length > 0)
        this.GroupDocDisplay.push(
          this.files.filter((item) => item.deviate_flag)
        );
    } catch (error) {
      this.goLandingPage();
    }
  },
  methods: {
    initData() {
      // this.docTypeItem = this.userData.documentType.find(
      //   (v) => v.doc_code == this.$route.params.doc_code
      // );
      if (this.documentType.filesReal) {
        this.realFiles.push(...this.documentType.filesReal);
      }
      this.realFiles.forEach((f) => {
        if (f.filesize != undefined) {
          this.size = this.size + parseInt(f.filesize);
        }
      });
      let value = this.documentType;
      let files = [];
      //Create file
      let item = {
        type: value.doc_code,
        name: value.doc_name,
        file: null,
      };
      let fieldList = Object.keys(value);
      for (let key of fieldList) {
        item[key] = value[key];
      }
      files.push(item);
      this.collapseObj[value.doc_code] = true;

      //Create fileGroupList
      let found = this.fileGroupList.find((v) => v.doc_group == value.doc_code);
      if (!found) {
        let groupItem = {
          doc_group: value.doc_code,
          doc_condition: value.doc_condition,
        };
        if (!groupItem.doc_group || !groupItem.doc_condition)
          groupItem.doc_group = value.doc_code;
        this.fileGroupList.push(groupItem);
      }

      this.files = files;
    },
    chooseFiles() {
      if (this.userData.isAndroid) {
        this.openDialogChooseFile();
      } else {
        this.defaultPopupIOS();
      }
    },

    defaultPopupIOS() {
      try {
        this.$callback.requestCamera();
        document.getElementById("fileBrowseIOS").click();
      } catch (error) {
        console.error("defaultPopupIOS");
        document.getElementById("fileBrowseIOS").click();
      }
    },

    selectedOptionFile(type) {
      try {
        if (type == 1) {
          try {
            this.$callback.requestCamera();
            // document.getElementById("fileCamera").click();
          } catch (error) {
            document.getElementById("fileCamera").click();
          }
        } else if (type == 2) {
          document.getElementById("fileBrowseImage").click();
        } else if (type == 3) {
          document.getElementById("fileBrowseFile").click();
        } else {
          document.getElementById("fileUpload").click();
        }
      } catch (error) {
        // document.getElementById("fileUpload").click();
      }
    },
    openDialogChooseFile() {
      this.modalShow = true;
    },

    async onFileChange(e) {
      this.modalShow = false;
      let key = this.$route.params.doc_code;

      let docTypeItem = this.userData.documentType.find(
        (v) => v.doc_code == key
      );

      const files = e?.target?.files || e?.dataTransfer?.files;
      let isErrorSize = false;
      let isErrorTypeFile = false;
      let isErrorEmptyFile = false;
      let isErrorFileNameDuplicate = false;
      let filenameDup = [];
      if (files?.length) {
        for (let draftFile of files) {
          let file = await convertFileCloudToLocal(draftFile);
          const size = this.size + file.size + 20;
          if (file.size == 0) {
            isErrorEmptyFile = true;
          } else {
            const istype = await this.checkFileType(file.type);
            if (istype) {
              let index = this.files.findIndex((v) => v.doc_code == key);
              if (index !== -1) {
                this.files[index].file = file;
                this.size = size;
              } else {
                alert("Error!. Please try again!");
              }

              if (
                this.realFiles.filter((i) => i.filename == file.name).length ==
                0
              ) {
                if (file.name === "image.jpg") {
                  file = this.renameFile(file, this.create_UUID() + ".png");
                }
                //Append to realFiles
                let tmpFile = {};
                tmpFile.id = this.create_UUID();
                tmpFile.type = docTypeItem.doc_code;
                tmpFile.name = docTypeItem.doc_name;
                tmpFile.file = file;
                tmpFile.status = false;
                tmpFile.filename = file.name;
                tmpFile.filesize = file.size;
                if ("image/heic" === file.type) {
                  this.convertHeicToJpg(
                    file,
                    docTypeItem.doc_code,
                    docTypeItem.doc_name
                  );
                } else if ("application/pdf" !== file.type) {
                  this.realFiles.push(tmpFile);
                } else {
                  this.validatePdf(tmpFile);
                }
              } else {
                filenameDup.push(file);

                this.size = this.size - file.size;
                isErrorFileNameDuplicate = true;
              }
            } else {
              isErrorTypeFile = true;
            }
          }
        }
        //Handle error message
        let alert = null;
        if (isErrorSize && isErrorTypeFile) alert = this.alert.sizeAndTypeFile;
        else if (isErrorSize) alert = this.alert.size;
        else if (isErrorTypeFile) alert = this.alert.typefile;
        else if (isErrorEmptyFile) alert = this.alert.fileEmpty;
        else if (isErrorFileNameDuplicate) {
          this.alertFilenameDuplicate(filenameDup);
        }
        if (alert) this.showAlertError(alert.title, alert.detail);
        try {
          document.getElementById("fileUpload").value = null;
          document.getElementById("fileCamera").value = null;
          document.getElementById("fileBrowseImage").value = null;
          document.getElementById("fileBrowseFile").value = null;
          document.getElementById("fileBrowseIOS").value = null;
        } catch (error) {
          console.error(error);
        }
      }
    },
    getListFileByType() {
      return this.realFiles;
    },
    checkFileType(type) {
      switch (type) {
        case "application/pdf":
          return true;
        case "image/jpeg":
          return true;
        case "image/png":
          return true;
        case "image/heic":
          return true;
        default:
          return false;
      }
    },
    renameFile(originalFile, newName) {
      return new File([originalFile], newName, {
        type: "image/png",
        lastModified: originalFile.lastModified,
      });
    },
    doSubmit() {
      this.saveLocalFile();
      if (this.isUploadStatement()) {
        this.goStatementDocument();
      } else {
        this.goPreUploadPage();
      }
    },
    saveLocalFile() {
      console.log(this.realFiles);
      this.userData.documentType.find(
        (v) => v.doc_code == this.$route.params.doc_code
      ).filesReal = this.realFiles;
      if (this.realFiles.length > 0) {
        this.userData.documentType.find(
          (v) => v.doc_code == this.$route.params.doc_code
        ).state = "attachfile";
      } else {
        this.userData.documentType.find(
          (v) => v.doc_code == this.$route.params.doc_code
        ).state = "wait";
      }
      this.userData.document_group_type.find(
        (i) => i.grp_id == this.grp_id
      ).state = "addDocument";
    },
    remove(key) {
      let size = this.size;
      const item = this.realFiles.find((v) => v.id == key);
      if (item != undefined && !item.status && item.file != undefined) {
        size = size - item.file.size;
        this.size = size >= 0 ? size : 0;
        this.realFiles = this.realFiles.filter((v) => v.id != key);
      }
    },
    viewDoc(key) {
      const data = this.realFiles.find((v) => v.id == key);
      const file = data.file;
      if (file != undefined) {
        const url = URL.createObjectURL(file);
        window.open(
          url,
          "popUpWindow",
          "height=400,width=600,left=10,top=10,,scrollbars=yes,menubar=no"
        );
      }
    },
    getPreview(key) {
      const data = this.getListFileByType().find((v) => v.id == key);
      const file = data.file;
      if (file) {
        if ("application/pdf" === file.type) {
          return require("@/assets/images/PDF File.png");
        }

        return URL.createObjectURL(file);
      }
    },
    getFileType(key) {
      const data = this.getListFileByType().find((v) => v.id == key);
      const file = data.file;
      if (file) {
        if ("application/pdf" === file.type) {
          return "pdf";
        }

        return "img";
      }
    },
    getFileSize(fSize) {
      var fSExt = new Array("Bytes", "KB", "MB", "GB");
      var i = 0;
      while (fSize > 900) {
        fSize /= 1024;
        i++;
      }
      return (Math.round(fSize * 100) / 100).toFixed(1) + " " + fSExt[i];
    },
    goLandingPage() {
      this.$router.push({
        name: this.userData.routerPath.landing,
      });
    },
    removeFileByDocCode(e, docCode) {
      this.files.find((item) => item.doc_code == docCode).doc_has_deviate =
        e.target.checked;
      this.getListFileByType().forEach((item) => {
        this.remove(item.id);
      });
    },
    create_UUID() {
      var dt = new Date().getTime();
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (dt + Math.random() * 16) % 16 | 0;
          dt = Math.floor(dt / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },
    goPreUploadPage() {
      this.$router.push({
        name: this.userData.routerPath.documentGroup,
        params: { grpId: this.userData.grpId },
      });
    },
    goStatementDocument() {
      this.$router.push({
        name: this.userData.routerPath.documentGroup,
        params: { grpId: process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT },
      });
    },
    isUploadStatement() {
      let docGroup = this.userData.document_group_type.find(
        (i) => i.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      if (docGroup == undefined) return false;
      return docGroup.lst_doc_id.includes(this.$route.params.doc_code);
    },
    getAllSize() {
      let bytes = 0;
      this.realFiles.forEach((i) => {
        bytes = bytes + i.filesize;
      });
      return (bytes / (1024 * 1024)).toFixed(1);
    },
    getColorProgress() {
      if (this.getAllSize() > this.max) {
        return "danger";
      }
      return "";
    },
    checkLimit() {
      if (this.getAllSize() > this.max) {
        return false;
      }
      return true;
    },
    validatePdf(tmpFile) {
      let array = this.realFiles;
      const showAlertError = this.showAlertError;
      var loadingTask = pdf.createLoadingTask(
        URL.createObjectURL(tmpFile.file)
      );
      loadingTask.promise.then(function () {
        array.push(tmpFile);
      });
      loadingTask.promise.catch(function (error) {
        if (error !== undefined && error.name !== undefined) {
          if (error.name == "PasswordException") {
            tmpFile.fileHavePassword = true;
            tmpFile.fileCheckassword = null;
            array.push(tmpFile);
          } else if (error.name == "InvalidPDFException") {
            showAlertError(
              "ไฟล์มีปัญหา",
              "พบไฟล์ชื่อ " + tmpFile.file.name + " ไม่สามารถเปิดไฟล์ได้"
            );
          } else {
            showAlertError(error.name, error.message);
          }
        } else {
          tmpFile.fileCheckassword = null;
          tmpFile.fileHavePassword = true;
          array.push(tmpFile);
        }
      });
      loadingTask.promise.finally(function () {
        loadingTask.destroy();
      });
    },
    validatePdfCaseDuplicate(tmpFile, index) {
      let array = this.realFiles;
      const showAlertError = this.showAlertError;
      var loadingTask = pdf.createLoadingTask(
        URL.createObjectURL(tmpFile.file)
      );
      loadingTask.promise.then(function () {
        array[index] = tmpFile;
      });
      loadingTask.promise.catch(function (error) {
        if (error !== undefined && error.name !== undefined) {
          if (error.name == "PasswordException") {
            tmpFile.fileHavePassword = true;
            tmpFile.fileCheckassword = null;
            // array.push(tmpFile);
          } else if (error.name == "InvalidPDFException") {
            showAlertError(
              "ไฟล์มีปัญหา",
              "พบไฟล์ชื่อ " + tmpFile.file.name + " ไม่สามารถเปิดไฟล์ได้"
            );
          } else {
            showAlertError(error.name, error.message);
          }
        } else {
          tmpFile.fileHavePassword = true;
          tmpFile.fileCheckassword = null;
          // array.push(tmpFile);
        }
      });
      loadingTask.promise.finally(function () {
        loadingTask.destroy();
      });
    },
    validateFileHavePassword(tmpFile, event) {
      try {
        tmpFile.fileCheckassword = false;
        const password = event.target.value;
        var loadingTask = pdf.createLoadingTask(
          URL.createObjectURL(tmpFile.file)
        );
        loadingTask.onPassword = function (updatePassword) {
          updatePassword(password);
        };
        loadingTask.promise.then(function () {
          tmpFile.fileHavePassword = false;
          tmpFile.fileCheckassword = true;
          tmpFile.password = password;
        });
        loadingTask.promise.finally(function () {
          loadingTask.destroy();
        });
      } catch (error) {
        console.error(error);
      }
    },
    validateTotalPdf() {
      return this.realFiles.filter((item) => item.fileHavePassword).length == 0;
    },
    alertFilenameDuplicate(filenameDup) {
      const chanel = this.userData.channel;
      let message =
        "พบเอกสารที่มีชื่อซ้ำกัน หากยืนยัน <br>ระบบจะบันทึกเอกสารทับเอกสารเดิม";
      let i = 0;
      filenameDup.forEach((p) => {
        if (i > 0) message += ",";
        message += '<br>"' + p.name + '"';
        i++;
      });
      this.$swal
        .fire({
          imageUrl: require("@/assets/images/foundationIllustrationGenericInformation@3x.png"),
          position: "bottom",
          title: "ยืนยันบันทึกเอกสารใหม่ทับเอกสารเดิม?",
          html: message,
          padding: "1em",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "เลือกใหม่",
          confirmButtonColor: "#00A3E4",
          reverseButtons: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          buttonsStyling: false,
          customClass: {
            title: "swal-title-duplication-file",
            confirmButton: "btn btn-info btn-ktb-NEXT btn-swal-width",
            cancelButton:
              "btn btn-info  btn-ktb-NEXT btn-ktb-cancel btn-swal-width",
            popup: "swal2-modal-" + chanel,
            image: "swal2-image-" + chanel,
            htmlContainer: "html-container-file-duplication",
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.updateFileDuplicate(filenameDup);
          }
        });
    },
    async updateFileDuplicate(files) {
      let key = this.$route.params.doc_code;

      let docTypeItem = this.userData.documentType.find(
        (v) => v.doc_code == key
      );
      for (let file of files) {
        const size = this.size + file.size;
        const istype = await this.checkFileType(file.type);
        if (istype) {
          let index = this.files.findIndex((v) => v.doc_code == key);
          if (index !== -1) {
            this.files[index].file = file;
            this.size = size;
          } else {
            alert("Error!. Please try again!");
          }
          //Append to realFiles
          let indexFile = -1;
          let tmpFile = {};
          for (var i = 0; i < this.realFiles.length; i++) {
            if (this.realFiles[i].filename == file.name) {
              tmpFile = this.realFiles[i];
              indexFile = i;
              break;
            }
          }

          if (indexFile > -1) {
            tmpFile.type = docTypeItem.doc_code;
            tmpFile.name = docTypeItem.doc_name;
            tmpFile.file = file;
            tmpFile.status = false;
            tmpFile.filename = file.name;
            tmpFile.filesize = file.size;
            if ("application/pdf" !== file.type) {
              this.realFiles[indexFile] = tmpFile;
            } else {
              this.validatePdfCaseDuplicate(tmpFile, indexFile);
            }
          }
        } else {
          // isErrorTypeFile = true;
        }
      }
    },
    showAlertError(title, message) {
      const chanel = this.userData.channel;
      this.$swal.fire({
        imageUrl: require("@/assets/images/Error@3x.png"),
        position: "bottom",
        title: title,
        text: message,
        padding: "1em",
        confirmButtonText: "ตกลง",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        customClass: {
          title: "swal-text-title",
          confirmButton:
            "btn btn-info rounded-pill btn-block btn-ktb-NEXT btn-alert-submit",
          popup: "swal2-modal-" + chanel,
          image: "swal2-image-" + chanel,
        },
      });
    },
    checkDocIsSuccess() {
      const data = this.userData.documentType.find(
        (v) => v.doc_code == this.$route.params.doc_code
      );
      return data.state != undefined && data.state == "success";
    },
    closeModalShowBackStep() {
      this.modalShowBackStep = false;
    },
    goToPreviousPage() {
      let userDataRealFilesId = [];
      let userDataRealFiles = this.userData.documentType.find(
        (v) => v.doc_code == this.$route.params.doc_code
      ).filesReal;
      userDataRealFiles.forEach((e) => userDataRealFilesId.push(e.id));
      userDataRealFilesId.slice().sort();

      let realFilesId = [];
      this.realFiles.forEach((e) => realFilesId.push(e.id));
      realFilesId.slice().sort();

      let compare =
        userDataRealFilesId.length === realFilesId.length &&
        userDataRealFilesId
          .slice()
          .sort()
          .every(function (value, index) {
            return value === realFilesId[index];
          });

      if (!compare) {
        this.modalShowBackStep = true;
      } else {
        this.backPage();
      }
    },
    backPage() {
      if (this.validateTotalPdf() && this.checkLimit()) this.saveLocalFile();
      let param = this.currentMenu.params;
      if (param != undefined && param.grpId != undefined) {
        this.$router.push({
          name: this.currentMenu.previousPage,
          params: { grpId: param.grpId },
        });
      } else {
        this.$router.push({
          name: this.currentMenu.previousPage,
        });
      }
    },
    calcHeight() {
      var h = window.innerHeight;
      return h < 680;
    },
    setIsConvertingHeic(value) {
      this.isConvertingHeic = value;
    },
    convertHeicToJpg(fileHeic, docCode, docName) {
      const showAlertError = this.showAlertError;
      const create_UUID = this.create_UUID;
      const setConvertingHeic = this.setIsConvertingHeic;
      const realFiles = this.realFiles;
      setConvertingHeic(true);
      var fileName =
        fileHeic.name.substring(0, fileHeic.name.lastIndexOf(".") + 1) ||
        fileHeic.name;
      var reader = new FileReader();
      reader.onload = function () {
        const blob = new Blob([reader.result], { type: "image/heic" });
        const data = heic2any({ blob, toType: "image/jpeg" });
        data
          .then((conversionResult) => {
            const file = new File([conversionResult], fileName + "jpeg", {
              type: "image/jpeg",
            });
            let tmpFile = {};
            tmpFile.id = create_UUID();
            tmpFile.type = docCode;
            tmpFile.name = docName;
            tmpFile.file = file;
            tmpFile.status = false;
            tmpFile.filename = file.name;
            tmpFile.filesize = file.size;
            realFiles.push(tmpFile);
            console.log(tmpFile);
            setConvertingHeic(false);
          })
          .catch((e) => {
            setConvertingHeic(false);
            console.log(e);
            showAlertError(
              "แปลงสกุลไฟล์ .heic  ไม่สำเร็จ",
              "กรุณาลองใช้ไฟล์นามสกุลเช่น JPG หรือ PNG"
            );
          });
      };
      reader.readAsArrayBuffer(fileHeic);
    },
  },
};
</script>

<style>
.btn-swal-width {
  width: 45%;
  margin-left: 0.5rem;
}

.btn-ktb-cancel {
  color: #00a6e6 !important;
  background-color: white !important;
  border-color: #00a6e6 !important;
  border: 1 !important;
  background-image: unset !important;
}

a {
  color: black;
  text-decoration: none;
}

a:hover,
a:focus {
  color: black;
  text-decoration: none;
}

.deviate-text {
  color: #ff6961;
  font-size: 0.75rem;
}

.document-info>.title {
  color: #00a3e4;
}

.document-info>.header {
  color: #000000;
}

.document-info>.body {
  color: #8e94a4;
}

.btn-upload-true {
  background-color: #3f62f1 !important;
  color: #3c68ce !important;
  border-color: #e3e4e8 !important;
}

.btn-ktb-deviate {
  background-color: white !important;
  color: #df0747 !important;
  border-color: #f93972 !important;
}

.btn-goback {
  background-color: white !important;
  color: #00a3e4 !important;
  border-color: #00a3e4 !important;
}

.text-upload-true {
  color: #aaafbb !important;
}

.alert-warning {
  color: #b98f13;
  background-color: #fdf8e7;
  border-color: #ffeeba;
  border-left-color: #f5d470;
  border-left-width: 4px;
}

.text-blue {
  color: rgb(0, 166, 230) !important;
}

.status-color-2 {
  color: #daa60b !important;
}

.status-color-3 {
  color: #479e6a !important;
}

.status-color-6 {
  color: #aaafbb !important;
}

.status-color-5,
.status-color-1,
.status-color-4 {
  color: #df0747 !important;
}

.progress-upload-custom {
  height: 0.4rem !important;
  margin-left: 50px !important;
  margin-right: 50px !important;
}

.progress-bar {
  background-color: rgb(0, 166, 230);
}

.progress-bar>.bg-danger {
  background-color: rgb(219, 0, 0);
}

.use-memory {
  text-align: center;
}

.size-memory {
  margin: 0;
  font-family: KrungthaiFast-Bold, Arial, sans-serif !important;
  color: rgb(0, 166, 230) !important;
  font-size: 14px !important;
}

.badge-primary {
  border: 1.5px solid #33c5ff;
  box-sizing: border-box;
  position: absolute;
  margin: -10px 0px;
  margin-top: 0rem;
  color: #33c5ff;
  background-color: transparent;
  width: 20px;
  height: 20px;
}

.text-document {
  color: #919595;
}

.upload-button {
  background-color: white;
  width: 343px;
  height: 78px;
  color: rgb(0, 166, 230);
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='16' ry='16' stroke='%23BCCCD6FF' stroke-width='4' stroke-dasharray='8' stroke-dashoffset='41' stroke-linecap='square'/%3e%3c/svg%3e");
  border-radius: 16px;
  border: unset;
}

.body-style {
  padding-left: 0px;
  padding-right: 0px;
}

.hr-style {
  margin-top: 0rem;
  margin-bottom: 0rem;
}

.preview-img {
  width: 43px;
  border: 1px solid rgb(188, 204, 214);
  border-radius: 8px;
}

.preview-pdf {
  width: 43px;
  border-radius: 5px;
}

.upload-header {
  font-family: KrungthaiFast-Bold, Arial, sans-serif !important;
  color: black !important;
  font-size: 20px;
}

.view-example {
  text-decoration: underline;
  color: #087ffd !important;
}

.text-danger {
  text-align: center;
  color: rgb(219, 0, 0);
  font-family: KrungthaiFast-Regular, Arial, sans-serif !important;
  font-size: 14px !important;
}

.btn-secondary.disabled,
.btn-secondary:disabled {
  background-color: #8e94a4 !important;
  border-color: #8e94a4 !important;
  background-image: linear-gradient(-90deg, #00b3f0, #006a9e) !important;
}

.danger-true {
  color: rgb(219, 0, 0);
}

.content-nowrap {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-left: unset;
}

.card-doc-err {
  background-color: rgb(236, 146, 14);
  border-radius: 16px !important;
  border: 1px solid rgb(236, 146, 14);
  margin-bottom: 10px;
  box-shadow: 0px 2px 4px 0px rgb(188, 204, 214, 0.4) !important;
}

.card-doc-err-detail {
  color: white;
}

.format-pre pre {
  background: #49483e;
  color: #f7f7f7;
  padding: 10px;
  font-size: 14px;
}

.modal-dialog-centered {
  display: grid;
  align-items: end;
  min-height: calc(100% - 1rem);
}

.btn-noborder {
  background-color: #ffffff;
  border-color: #ffffff;
  color: black;
}

.vl {
  border-left: 1px solid gray;
  height: 100px;
}

.btn-back-step {
  width: inherit;
  color: #00a3e4;
  background-color: #ffffff;
  border-color: #ffffff;
  border-radius: unset;
}

.text-header-center {
  text-align: center;
  font-size: 20px;
}

.icon-back {
  color: #00a7ec;
}

.badge-ktb-info {
  box-sizing: border-box;
  position: absolute;
  margin: -10px -10px;
  margin-top: 0rem;
  color: rgb(0, 166, 230) !important;
  background-color: transparent;
  width: 24px;
  height: 24px;
}

.badge-primary {
  border: 2px solid rgb(0, 166, 230);
  box-sizing: border-box;
  position: absolute;
  margin: -10px 0px;
  margin-top: 2px;
  color: rgb(0, 166, 230) !important;
  background-color: transparent;
  width: 24px;
  height: 24px;
}

.modal-attachfile-modal_content {
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 16px 16px 0 0;
  outline: 0;
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
}

.uploads-content-card-md {
  min-height: 43%;
}

.uploads-content-card-sm {
  min-height: 23%;
}

.form-control.is-invalid,
.was-validated .form-control:invalid {
  background-image: unset !important;
}

.html-container-file-duplication {
  line-height: 18px !important;
  letter-spacing: -0.5px !important;
}
</style>
